import { sortBy } from 'lodash-es';
import { COLUMNS_PANEL_GAP, COLUMNS_PANEL_MIN_HEIGHT, COLUMNS_PANEL_WINDOW_MARGIN } from '../../tableCore/table.constants';
export function toPanelEntries(param) {
    let { allColumns, columnsState } = param;
    return allColumns.map((column)=>({
            id: column.id,
            label: column.label,
            hidden: columnsState.hidden.includes(column.id),
            frozen: column.frozen,
            isMain: column.isMain
        }));
}
export const columnsPanelMaxHeight = (param)=>{
    let { windowHeight, triggerBottom } = param;
    return Math.max(COLUMNS_PANEL_MIN_HEIGHT, windowHeight - triggerBottom - COLUMNS_PANEL_GAP - COLUMNS_PANEL_WINDOW_MARGIN);
};
export const inRowOrder = (entries, rowOrder)=>sortBy(entries, (param)=>{
        let { id } = param;
        return rowOrder.includes(id) ? rowOrder.indexOf(id) : rowOrder.length;
    });
